import axios from "axios";
import { ApiHost } from "../utils/ApiConfig";
import config from "../config";


import logger from "../utils/logger";
const debug = config.runmode.debug;

const Payment = {
  order: async (
    applicationId,
    userId,
    amount,
    applicationNumber,
    accessToken
  ) => {
    try {
      if (debug)
        logger.log("Tworzenie zamówienia dla wniosku [" + applicationId + "]");
      const response = await axios.post(
        ApiHost + `/payu/order`,
        {
          order_id: applicationId,
          user_id: userId,
          amount: amount,
          application_number: applicationNumber,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        let result = response.data;
        if (debug)
          logger.log("createOrder - content: ", JSON.stringify(result));
        logger.log("createOrder - URI: ", result.redirect_uri);
        return result.redirect_uri;
      }
    } catch (error) {
      logger.error("Błąd podczas tworzenia zamówienia dla wniosku: ", error);
      throw error;
    }
  },

  verify: async (applicationId, accessToken) => {
    try {
      if (debug)
        logger.log(
          "Weryfikacja płatności dla wniosku [" + applicationId + "]"
        );
      const response = await axios.get(
        ApiHost + `/payu/verify/` + applicationId,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        let result = response.data;
        if (debug)
          logger.log("verifyPayment - content: ", JSON.stringify(result));
        return result;
      }
    } catch (error) {
      logger.error("Błąd podczas weryfikacji płatności dla wniosku: ", error);
      throw error;
    }
  },

  getStatus: async (applicationId, accessToken) => {
    try {
      if (debug)
        logger.log(
          "Sprawdzanie statusu płatności dla wniosku [" + applicationId + "]"
        );

      const response = await axios.get(
        ApiHost + `/payu/status/` + applicationId,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          timeout: 10000,
        }
      );

      if (response.status === 200) {
        let result = response.data;
        if (debug) logger.log("getStatus - content: ", JSON.stringify(result));
        return result;
      }
    } catch (error) {
      if (error.code === "ECONNABORTED") {
        logger.warn("Timeout podczas sprawdzania statusu płatności");
      } else {
        logger.error("Błąd podczas sprawdzania statusu płatności: ", error);
      }
      throw error;
    }
  },

  forceRefresh: async (applicationId, accessToken) => {
    try {
      if (debug)
        logger.log(
          "Wymuszone odświeżenie statusu płatności dla wniosku [" +
            applicationId +
            "]"
        );

      const response = await axios.post(
        ApiHost + `/payu/refresh/` + applicationId,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          timeout: 15000,
        }
      );

      if (response.status === 200) {
        let result = response.data;
        if (debug)
          logger.log("forceRefresh - content: ", JSON.stringify(result));
        return result;
      }
    } catch (error) {
      logger.error("Błąd podczas wymuszonego odświeżenia płatności: ", error);
      throw error;
    }
  },

  getPaymentHistory: async (applicationId, accessToken) => {
    try {
      const response = await axios.get(
        ApiHost + `/payu/history/` + applicationId,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      logger.error("Błąd podczas pobierania historii płatności: ", error);
      throw error;
    }
  },
};

export default Payment;


